export const NAV_ITEMS_HOME: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Кому підійде', href: '#section-1' },
  { label: 'Що входить', href: '#section-2' },
  { label: 'Результати', href: '#section-3' },
  { label: 'Про мене', href: '#section-4' },
  { label: 'Відгуки', href: '#section-5' },
  { label: 'FAQ', href: '#section-6' },
]

export const NAV_ITEMS_SNACKS: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Для кого', href: '#section-1' },
  { label: 'Переваги', href: '#section-2' },
  { label: 'Що готуємо', href: '#section-3' },
  { label: 'Відгуки', href: '#section-4' },
  { label: 'FAQ', href: '#section-5' },
]

export const NAV_ITEMS_RACION: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Що отримуєш', href: '#section-1' },
  { label: 'Що входить', href: '#section-2' },
  { label: 'Замовити', href: '#section-3' },
  { label: 'FAQ', href: '#section-4' },
]

export const NAV_ITEMS_CALCULATOR: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Розрахунок', href: '#section-1' },
]

export const NAV_ITEMS_GYM: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Що входить', href: '#section-1' },
  { label: 'Формат', href: '#section-2' },
  { label: 'Отримати', href: '#section-3' },
  { label: 'FAQ', href: '#section-4' },
]

export const PRODUCTS: ReadonlyArray<{ label: string; href: string; description: string }> = [
  { label: 'TiloVdoma', href: '/', description: 'Онлайн-курс домашніх тренувань' },
  { label: 'Програма для залу', href: '/gym', description: 'Тренування в залі з акцентом на сідниці' },
  { label: 'Здорові Снеки', href: '/snacks', description: 'Збірка рецептів корисних снеків' },
  { label: 'Індивідуальний Раціон', href: '/racion', description: 'Персональний план харчування' },
]
